/**
 * レイヤ名を現すenum
 */
export enum LayerName {
  /** 国土地理院標準地図 */
  StdMapTile = "国土地理院標準地図",
  /** 国土地理院白地図 */
  BlankMapTile = "国土地理院白地図",
  /** 国土地理院航空写真 */
  SeamlessphotoMapTile = "国土地理院航空写真",
  /** 国土地理院淡色地図 */
  PaleMapTile = "国土地理院淡色地図",
  /** 距離計測 */
  MeasureDistance = "距離計測",
  /** 面積計測 */
  MeasureArea = "面積計測",
  /** 地物選択 */
  SelectedFeature = "地物選択",
  /** OD量発ノード */
  ODNodeDeparture = "OD量発ノード",
  /** OD量着ノード */
  ODNodeArrival = "OD量着ノード",

  /** 発集量_Bゾーン_乗用車 */
  t_od_btz_bzone_passenger_car = "t_od_btz_bzone_passenger_car",
  /** 発集量_Bゾーン_小型貨物車 */
  t_od_btz_bzone_small_cargo = "t_od_btz_bzone_small_cargo",
  /** 発集量_Bゾーン_普通貨物車 */
  t_od_btz_bzone_normal_cargo = "t_od_btz_bzone_normal_cargo",
  /** 発集量_Bゾーン_車種計 */
  t_od_btz_bzone_total = "t_od_btz_bzone_total",
  /** 発集量_市区町村_乗用車 */
  t_od_btz_city_passenger_car = "t_od_btz_city_passenger_car",
  /** 発集量_市区町村_小型貨物車 */
  t_od_btz_city_small_cargo = "t_od_btz_city_small_cargo",
  /** 発集量_市区町村_普通貨物車 */
  t_od_btz_city_normal_cargo = "t_od_btz_city_normal_cargo",
  /** 発集量_市区町村_車種計 */
  t_od_btz_city_total = "t_od_btz_city_total",
  /** 発集量_都道府県_乗用車 */
  t_od_btz_pref_passenger_car = "t_od_btz_pref_passenger_car",
  /** 発集量_都道府県_小型貨物車 */
  t_od_btz_pref_small_cargo = "t_od_btz_pref_small_cargo",
  /** 発集量_都道府県_普通貨物車 */
  t_od_btz_pref_normal_cargo = "t_od_btz_pref_normal_cargo",
  /** 発集量_都道府県_車種計 */
  t_od_btz_pref_total = "t_od_btz_pref_total",

  // LayerNameにLayerFactoryに登録されているキーがないとレイヤが表示できない
  ODDepartureAndArrival = "ODDepartureAndArrival",

  /** ODゾーン */
  ODZone = "ODZone",

  /** 点検データ（道路橋） */
  RoadStructuresBridges = "点検データ（道路橋）",
  /** 点検データ（トンネル） */
  RoadStructuresTunnels = "点検データ（トンネル）",
  /** 点検データ（シェッド） */
  RoadStructuresSheds = "点検データ（シェッド）",
  /** 点検データ（大型カルバート） */
  RoadStructuresCulverts = "点検データ（大型カルバート）",
  /** 点検データ（横断歩道橋） */
  RoadStructuresPedestrianDecks = "点検データ（横断歩道橋）",
  /** 点検データ（門型標識等） */
  RoadStructuresOverheadSignages = "点検データ（門型標識等）",
  /** 点検データ（舗装） */
  RoadStructuresPavements = "点検データ（舗装）",
  /** 点検データ（特定道路⼟⼯構造物） */
  RoadStructuresEarthworks = "点検データ（特定道路⼟⼯構造物）",

  /** ベクタ取込 */
  ImportVector = "ベクタ取込",

  /** DRMノード */
  DrmNodeMap = "DRMノード",
  /** DRMリンク */
  DrmLinkMap = "DRMリンク",

  /** Travos_計測値５分 */
  t_travospublic_measure_5m = "Travos_計測値５分",
  /** Travos_計測値１時間 */
  t_travospublic_measure_1h = "Travos_計測値１時間",
  /** Travos_確定値１時間 */
  t_travospublic_define_1h = "Travos_確定値１時間",
  /** Travos_交通基本調査区間 */
  t_travospublic_traffic_basic_sec = "Travos_交通基本調査区間",
  /** Travos_計測値５分（画像認識型） */
  t_travospublic_measure_5m_img = "Travos_計測値５分（画像認識型）",
  /** Travos_計測値１時間（画像認識型） */
  t_travospublic_measure_1h_img = "Travos_計測値１時間（画像認識型）",
  /** Travos_確定値１時間（画像認識型） */
  t_travospublic_define_1h_img = "Travos_確定値１時間（画像認識型）",

  /** TraVos */
  TraVos = "TraVos",
  /** ETC */
  ETC = "ETC",
  /** ETC_DRM区間_15分（論理） */
  t_etc_probe_drm_lnk_15m_logic = "ETC_DRM区間_15分",
  /** ETC_DRM区間_15分（物理） */
  t_etc_probe_drm_lnk_15m = "t_etc_probe_drm_lnk_15m",
  /** ETC_DRM区間_時間（論理） */
  t_etc_probe_drm_lnk_1h_logic = "ETC_DRM区間_時間",
  /** ETC_DRM区間_時間（物理） */
  t_etc_probe_drm_lnk_1h = "t_etc_probe_drm_lnk_1h",
  /** ETC_DRM区間_月（論理） */
  t_etc_probe_drm_lnk_1M_logic = "ETC_DRM区間_月",
  /** ETC_DRM区間_月（物理） */
  t_etc_probe_drm_lnk_1M = "t_etc_probe_drm_lnk_1M",
  /** ETC_交通調査基本区間_15分（論理） */
  t_etc_probe_traffic_15m_logic = "ETC_交通調査基本区間_15分",
  /** ETC_交通調査基本区間_15分（物理） */
  t_etc_probe_traffic_15m = "t_etc_probe_traffic_15m",
  /** ETC_交通調査基本区間_時間（論理） */
  t_etc_probe_traffic_1h_logic = "ETC_交通調査基本区間_時間",
  /** ETC_交通調査基本区間_時間（物理） */
  t_etc_probe_traffic_1h = "t_etc_probe_traffic_1h",
  /** ETC_交通調査基本区間_月（論理） */
  t_etc_probe_traffic_1M_logic = "ETC_交通調査基本区間_月",
  /** ETC_交通調査基本区間_月（物理） */
  t_etc_probe_traffic_1M = "t_etc_probe_traffic_1M",

  /** OD量 */
  ODNode = "ODNode",
  /** OD量発ゾーン情報_Bゾーン_乗用車レイヤ名 */
  t_od_stzone_bzone_passenger_car = "t_od_stzone_bzone_passenger_car",
  /** OD量発ゾーン情報_Bゾーン_小型貨物車レイヤ名 */
  t_od_stzone_bzone_small_cargo = "t_od_stzone_bzone_small_cargo",
  /** OD量発ゾーン情報_Bゾーン_普通貨物車レイヤ名 */
  t_od_stzone_bzone_normal_cargo = "t_od_stzone_bzone_normal_cargo",
  /** OD量発ゾーン情報_Bゾーン_車種計レイヤ名 */
  t_od_stzone_bzone_total = "t_od_stzone_bzone_total",
  /** OD量発ゾーン情報_市区町村_乗用車レイヤ名 */
  t_od_stzone_city_passenger_car = "t_od_stzone_city_passenger_car",
  /** OD量発ゾーン情報_市区町村_小型貨物車レイヤ名 */
  t_od_stzone_city_small_cargo = "t_od_stzone_city_small_cargo",
  /** OD量発ゾーン情報_市区町村_普通貨物車レイヤ名 */
  t_od_stzone_city_normal_cargo = "t_od_stzone_city_normal_cargo",
  /** OD量発ゾーン情報_市区町村_車種計レイヤ名 */
  t_od_stzone_city_total = "t_od_stzone_city_total",
  /** OD量発ゾーン情報_都道府県_乗用車レイヤ名 */
  t_od_stzone_pref_passenger_car = "t_od_stzone_pref_passenger_car",
  /** OD量発ゾーン情報_都道府県_小型貨物車レイヤ名 */
  t_od_stzone_pref_small_cargo = "t_od_stzone_pref_small_cargo",
  /** OD量発ゾーン情報_都道府県_普通貨物車レイヤ名 */
  t_od_stzone_pref_normal_cargo = "t_od_stzone_pref_normal_cargo",
  /** OD量発ゾーン情報_都道府県_車種計レイヤ名 */
  t_od_stzone_pref_total = "t_od_stzone_pref_total",
  /** OD量着ゾーン情報_Bゾーン_乗用車レイヤ名 */
  t_od_arzone_bzone_passenger_car = "t_od_arzone_bzone_passenger_car",
  /** OD量着ゾーン情報_Bゾーン_小型貨物車レイヤ名 */
  t_od_arzone_bzone_small_cargo = "t_od_arzone_bzone_small_cargo",
  /** OD量着ゾーン情報_Bゾーン_普通貨物車レイヤ名 */
  t_od_arzone_bzone_normal_cargo = "t_od_arzone_bzone_normal_cargo",
  /** OD量着ゾーン情報_Bゾーン_車種計レイヤ名 */
  t_od_arzone_bzone_total = "t_od_arzone_bzone_total",
  /** OD量着ゾーン情報_市区町村_乗用車レイヤ名 */
  t_od_arzone_city_passenger_car = "t_od_arzone_city_passenger_car",
  /** OD量着ゾーン情報_市区町村_小型貨物車レイヤ名 */
  t_od_arzone_city_small_cargo = "t_od_arzone_city_small_cargo",
  /** OD量着ゾーン情報_市区町村_普通貨物車レイヤ名 */
  t_od_arzone_city_normal_cargo = "t_od_arzone_city_normal_cargo",
  /** OD量着ゾーン情報_市区町村_車種計レイヤ名 */
  t_od_arzone_city_total = "t_od_arzone_city_total",
  /** OD量着ゾーン情報_都道府県_乗用車レイヤ名 */
  t_od_arzone_pref_passenger_car = "t_od_arzone_pref_passenger_car",
  /** OD量着ゾーン情報_都道府県_小型貨物車レイヤ名 */
  t_od_arzone_pref_small_cargo = "t_od_arzone_pref_small_cargo",
  /** OD量着ゾーン情報_都道府県_普通貨物車レイヤ名 */
  t_od_arzone_pref_normal_cargo = "t_od_arzone_pref_normal_cargo",
  /** OD量着ゾーン情報_都道府県_車種計レイヤ名 */
  t_od_arzone_pref_total = "t_od_arzone_pref_total",

  /** 道路属性 */
  RoadAttribute = "道路属性",

  /** 市区町村選択レイヤ */
  ExportAreaSelect = "市区町村選択",

  /** ベクタ読み込み */
  GeoJson = "ベクタ読み込み",
}

const enumKeys = Object.keys(LayerName);
const enumValues = Object.values(LayerName);

/**
 * レイヤ名称からenumのkey名を取得
 * @param layerName レイヤ名称
 */
export const getLayerKey = (layerName: string) => {
  const index = enumValues.indexOf(layerName as LayerName);
  if (index >= 0) {
    return enumKeys[index] as string;
  }
  return null;
};
